import React, { Fragment } from 'react'

const instruments = () => {
  return (
    <Fragment>
      <h1 style={{ margin: '50px' }}>Setting Instruments</h1>
    </Fragment>
  )
}

export default instruments
